module.exports = __webpack_public_path__ + "static/img/brand-title-bg.043e6d47.png";